<template>
  <div class="c-target-wrap" :class="{ 'disabled-wrap': disabled }">
    <!-- <Spin size="large" fix v-if="!show" /> -->
    <Row class="row-item" :gutter="12" v-if="!isBatch">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">项目组合名称</span>
      </Col>
      <Col span="12">
        <input-len :value="planName" placeholder="最大20个字符，1个中文等于2个字符" width="480" :max="20" @change="changePlanName" />
      </Col>
    </Row>
    <template v-if="isManual">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">投放位置</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.inventory_catalog" type="button">
            <Radio label="MANUAL">首选媒体</Radio>
            <Radio label="UNIVERSAL_SMART" disabled>通投智选</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <Checkbox v-model="inventoryAll"> 全选 </Checkbox>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <CheckboxGroup v-model="plan.inventory_type">
            <Checkbox label="INVENTORY_FEED">今日头条</Checkbox>
            <Checkbox label="INVENTORY_VIDEO_FEED">西瓜视频</Checkbox>
            <Checkbox label="INVENTORY_AWEME_FEED">抖音短视频</Checkbox>
            <!-- <Checkbox label="INVENTORY_HOTSOON_FEED" v-if="is_android">抖音火山版</Checkbox> -->
            <Checkbox label="INVENTORY_TOMATO_NOVEL">番茄小说</Checkbox>
            <Checkbox label="INVENTORY_UNION_SLOT">穿山甲</Checkbox>
            <!-- <Checkbox label="UNION_BOUTIQUE_GAME">ohayoo精品游戏</Checkbox> -->
          </CheckboxGroup>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12" v-if="superior">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">投放形式</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.union_video_type" type="button">
            <Radio label="REWARDED_VIDEO">激励视频</Radio>
            <Radio label="ORIGINAL_VIDEO">原生</Radio>
            <Radio label="SPLASH_VIDEO" disabled>开屏</Radio>
          </RadioGroup>
        </Col>
      </Row>
    </template>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <Poptip
          trigger="hover"
          placement="top-start"
          width="410"
          word-wrap
          content="接入您的应用或网站的数据, 选定或排除特定的用户。您可以在工具箱-头条DMP中管理人群包"
        >
          <Icon type="md-help-circle" size="18" color="#e3e3e3" />
        </Poptip>
        <span class="item-field">人群包</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="plan.retargeting_type" type="button" @on-change="changeRetarget">
          <Radio label="NONE">不限</Radio>
          <Radio label="RETARGETING_INCLUDE">定向或排除人群</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-if="plan.retargeting_type === 'RETARGETING_INCLUDE'">
      <Col span="3">&nbsp;</Col>
      <Col span="17">
        <audience
          ref="audience"
          v-model="currenTab"
          :accounts="accounts"
          :audience="audienceList"
          :current="current"
          :loading="loading"
          :data="plan.retargeting_tags"
          :delivery-mode="deliveryMode"
          @on-current="currentRetarget"
          @on-select="changeRetargetingTags"
          @on-select-all="changeRetargetAll"
          @on-clear="clearRetargetingTags"
          @on-delete="deleteRetargetingTags"
        />
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">地域</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="plan.district" type="button" @on-change="$emit('on-radio-change', 'cityData')">
          <Radio label="NONE">不限</Radio>
          <Radio label="REGION">按省市</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-if="plan.district === 'REGION'">
      <Col span="3">&nbsp;</Col>
      <Col span="14">
        <selecter
          v-model="mult_city"
          :data="data.cityData"
          :title="['省份', '城市']"
          @on-select="selectAll"
          @on-delete="delTag"
          @on-clear="clearTag"
        />
        <RadioGroup v-model="plan.location_type" style="margin-top: 32px">
          <Radio label="HOME">居住在该地区的用户</Radio>
          <Radio label="TRAVEL">到该地区旅行的用户</Radio>
          <Radio label="ALL">该地区内的所有用户</Radio>
          <Radio label="CURRENT">正在该地区的用户</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">性别</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="plan.gender" type="button">
          <Radio label="NONE">不限</Radio>
          <Radio label="GENDER_MALE">男</Radio>
          <Radio label="GENDER_FEMALE">女</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">年龄</span>
      </Col>
      <Col span="18">
        <Mixcheck v-model="plan.age">
          <radio-item label="NONE">不限</radio-item>
          <check-item label="AGE_BETWEEN_18_23">18-23岁</check-item>
          <check-item label="AGE_BETWEEN_24_30">24-30岁</check-item>
          <check-item label="AGE_BETWEEN_31_40">31-40岁</check-item>
          <check-item label="AGE_BETWEEN_41_49">41-49岁</check-item>
          <check-item label="AGE_ABOVE_50">大于等于50岁</check-item>
        </Mixcheck>
      </Col>
    </Row>
    <!-- 新版 -->
    <template v-if="isManual">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">行为兴趣定向</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.interest_action_mode" type="button" @on-change="resetInterestAction">
            <Radio label="UNLIMITED">不限</Radio>
            <Radio label="RECOMMEND">系统推荐</Radio>
            <Radio label="CUSTOM">自定义</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12" v-if="plan.interest_action_mode === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">行为</span>
        </Col>
        <Col span="15">
          <!-- 新版 -->
          <action-interest
            v-model="plan.action_tags"
            :accounts="accounts"
            :action-scene="plan.action_scene"
            :action-days="plan.action_days"
            :max="350"
            action
            @on-days="setDays"
            @on-scene="setScene"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="plan.interest_action_mode === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">兴趣</span>
        </Col>
        <Col span="15">
          <!-- 新版 -->
          <action-interest v-model="plan.word_tags" :accounts="accounts" :max="350" />
        </Col>
      </Row>
    </template>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">平台</span>
      </Col>
      <Col span="12">
        <!-- 小程序推广，可以选择平台 -->
        <Mixcheck v-model="plan.platform" v-if="landingType === 'MICRO_GAME'">
          <radio-item label="NONE">不限</radio-item>
          <check-item label="ANDROID">Android</check-item>
          <check-item label="IOS">iOS</check-item>
        </Mixcheck>

        <Mixcheck v-else v-model="plan.platform">
          <radio-item disabled label="NONE">不限</radio-item>
          <check-item disabled label="ANDROID">Android</check-item>
          <check-item disabled label="IOS">iOS</check-item>
        </Mixcheck>

        <!--  <RadioGroup v-model="plan.platform" v-if="landingType === 'MICRO_GAME'" type="button">
          <Radio label="NONE">不限</Radio>
          <Radio label="APP_ANDROID">Android</Radio>
          <Radio label="APP_IOS">iOS</Radio>
        </RadioGroup>

        <RadioGroup v-model="plan.platform" v-else type="button">
          <Radio label="NONE" disabled>不限</Radio>
          <Radio label="APP_ANDROID" disabled>Android</Radio>
          <Radio label="APP_IOS" disabled>iOS</Radio>
        </RadioGroup> -->
      </Col>
    </Row>

    <Row class="row-item" :gutter="12" v-if="is_android && downloadType !== 'EXTERNAL_URL'">
      <Col span="3" class="col-item">
        <span class="item-field">安卓版本</span>
      </Col>
      <Col span="12">
        <version v-model="plan.android_osv" :data="data.androidVersion" title="安卓版本" />
      </Col>
    </Row>

    <Row class="row-item" :gutter="12" v-if="is_iOS && downloadType !== 'EXTERNAL_URL'">
      <Col span="3" class="col-item">
        <span class="item-field">iOS版本</span>
      </Col>
      <Col span="12">
        <version v-model="plan.ios_osv" :data="data.iOSVersion" title="iOS版本" />
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">过滤已转化</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="plan.hide_if_converted" type="button">
          <Radio label="NO_EXCLUDE">不限制</Radio>
          <Radio label="PROMOTION">广告</Radio>
          <Radio label="PROJECT">推广项目</Radio>
          <Radio label="ADVERTISER">广告账户</Radio>
          <Radio label="APP" :disabled="landingType === 'MICRO_GAME'">APP</Radio>
          <Radio label="CUSTOMER">客户</Radio>
          <Radio label="ORGANIZATION">组织</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <template v-if="isManual">
      <Row class="row-item" :gutter="12" v-if="show">
        <Col span="3" class="col-item">
          <span class="item-field">设备类型</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.device" type="button" @on-change="changeDeviceType">
            <Radio label="NONE">不限</Radio>
            <Radio label="DEVICE">设备类型</Radio>
          </RadioGroup>
          <span style="color: #ff4400; margin-left: 12px; display: inline-block" v-if="plan.device === 'DEVICE'"
            >提示：非白名单账户会报错，慎重选择！</span
          >
        </Col>
      </Row>

      <Row v-if="plan.device === 'DEVICE'" class="row-item" :gutter="12">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <CheckboxGroup v-model="plan.device_type">
            <Checkbox label="MOBILE">智能手机</Checkbox>
            <Checkbox label="PAD">平板</Checkbox>
          </CheckboxGroup>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">智能放量</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.auto_extend_enabled" type="button" @on-change="$emit('on-radio-change', 'autotendData')">
            <Radio label="OFF">关闭</Radio>
            <Radio label="ON">开启</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="plan.auto_extend_enabled === 'ON'">
        <Col span="3">&nbsp;</Col>
        <Col span="12">
          <selecter
            v-model="mult_autotend"
            :data="data.autotendData"
            :title="['可放开定向']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">网络</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="plan.ac">
            <radio-item label="NONE">不限</radio-item>
            <check-item label="WIFI">WIFI</check-item>
            <check-item label="2G">2G</check-item>
            <check-item label="3G">3G</check-item>
            <check-item label="4G">4G</check-item>
            <check-item label="5G" :disabled="superior">5G</check-item>
          </Mixcheck>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">穿山甲媒体定向</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.superior_popularity_type" type="button" @on-change="changeMediaRetarget">
            <Radio label="NONE">不限</Radio>
            <Radio label="GAME" :disabled="!superior">游戏优质媒体</Radio>
            <Radio label="CUSTOM">自定义</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="plan.superior_popularity_type === 'CUSTOM'">
        <Col span="3">&nbsp;</Col>
        <Col span="17">
          <media-audience
            ref="audience"
            v-model="currenMediaTab"
            :accounts="accounts"
            :audience="mediaAudienceList"
            :current="current"
            :loading="loading"
            :data="plan.media_retargeting_tags"
            @on-current="currentMediaRetarget"
            @on-select="changeMediaRetargetingTags"
            @on-select-all="changeMediaRetargetAll"
            @on-clear="clearMediaRetargetingTags"
            @on-delete="deleteMediaRetargetingTags"
          />
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">运营商</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="plan.carrier">
            <radio-item label="NONE">不限</radio-item>
            <check-item label="MOBILE" :disabled="superior && landingType === 'APP'">移动</check-item>
            <check-item label="UNICOM" :disabled="superior && landingType === 'APP'">联通</check-item>
            <check-item label="TELCOM" :disabled="superior && landingType === 'APP'">电信</check-item>
          </Mixcheck>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="新用户使用头条的时间">
            <Icon type="md-help-circle" size="18" color="#e3e3e3" />
          </Poptip>
          <span class="item-field">新用户</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="plan.activate_type">
            <radio-item label="NONE">不限</radio-item>
            <check-item label="WITH_IN_A_MONTH" :disabled="superior && landingType === 'APP'">一个月以内</check-item>
            <check-item label="ONE_MONTH_2_THREE_MONTH" :disabled="superior && landingType === 'APP'">一个月到三个月</check-item>
            <check-item label="THREE_MONTH_EAILIER" :disabled="superior && landingType === 'APP'">三个月或更早</check-item>
          </Mixcheck>
        </Col>
      </Row>

      <template v-if="!isHideBrand">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">手机品牌</span>
          </Col>
          <Col span="12">
            <RadioGroup
              v-model="plan.brand"
              type="button"
              @on-change="$emit('on-radio-change', isShowAllBrand ? 'brandDataAll' : 'brandData')"
            >
              <Radio label="NONE">不限</Radio>
              <Radio label="BRAND">按手机品牌</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="plan.brand === 'BRAND'">
          <Col span="3">&nbsp;</Col>
          <Col span="12">
            <selecter
              v-model="mult_brand"
              :data="isShowAllBrand ? data.brandDataAll : data.brandData"
              :title="['手机品牌']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag"
            />
          </Col>
        </Row>
      </template>

      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">手机价格</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="plan.price" type="button" @on-change="changePrice">
            <Radio label="NONE">不限</Radio>
            <Radio label="CUSTOM">自定义</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12" v-if="plan.price === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span>&nbsp;</span>
        </Col>
        <Col span="10">
          <range-price v-model="plan.launch_price" @on-short="changePriceValue" :closeMarks="true" />
        </Col>
      </Row>
    </template>

    <Row class="row-item" :gutter="12" v-show="false">
      <Col span="3" class="col-item">
        <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="只针对投放在详情页位置的广告生效, 不支持人群预估">
          <Icon type="md-help-circle" size="18" color="#e3e3e3" />
        </Poptip>
        <span class="item-field">文章分类</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="plan.article" type="button" @on-change="$emit('on-radio-change', 'articleData')">
          <Radio label="NONE">不限</Radio>
          <Radio label="ARTICLE">文章分类</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-if="false && plan.article === 'ARTICLE'">
      <Col span="3">&nbsp;</Col>
      <Col span="12">
        <selecter
          v-model="mult_article"
          :data="data.articleData"
          :title="['文章分类']"
          @on-select="selectAll"
          @on-delete="delTag"
          @on-clear="clearTag"
        />
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, findCheck, getNameOfData, clearTagOfData, deepCopy } from '@/common/js/utils'

import Audience from './audience'
import MediaAudience from './media-audience'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Selecter from '@/components/select/selecter.vue'
import InputLen from '@/components/input/input-len'
import Version from '@/components/version/'
import RangePrice from '@/components/range-price/range-price'
import ActionInterest from '../actioninterest/'
import { getCustomAudience, getFlowPackage } from '@/api/toutiao.model'

export default {
  name: 'targeting',
  components: { InputLen, Audience, MediaAudience, Selecter, Mixcheck, CheckItem, RadioItem, Version, RangePrice, ActionInterest },
  props: {
    isBatch: {
      type: Boolean,
      default: false
    },
    accounts: {
      type: Array
    },
    plan: {
      type: Object
    },
    planName: {
      type: String
    },
    data: {
      type: Object
    },
    retargetingTags: {
      type: Array
    },
    landingType: {
      type: String
    },
    isLive: {
      type: Boolean
    },
    deliveryRange: {
      type: String
    },
    downloadType: {
      type: String
    },
    // ad: {
    //   type: String
    // },
    media: {
      type: [Number, String]
    },
    account: {
      type: [Number, String]
    },
    show: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    chPlatform: {
      type: Number
    },
    deliveryMode: {
      type: String,
      default() {
        return 'MANUAL'
      }
    }
  },
  computed: {
    isProcedual() {
      return this.deliveryMode === 'PROCEDURAL'
    },
    isManual() {
      return this.deliveryMode === 'MANUAL'
    },
    is_android() {
      return this.landingType === 'APP' && this.chPlatform === 1
    },
    is_iOS() {
      return this.landingType === 'APP' && this.chPlatform === 2
    },
    superior() {
      return this.plan.inventory_type
        ? this.plan.inventory_type.length === 1 && this.plan.inventory_type.includes('INVENTORY_UNION_SLOT')
        : false
    },
    mult_city() {
      return findCheck(this.data.cityData)
    },
    mult_tags() {
      return findCheck(this.data.tagsData)
    },
    mult_gategory() {
      return findCheck(this.data.gategoryData)
    },
    mult_brand() {
      return this.isShowAllBrand ? findCheck(this.data.brandDataAll) : findCheck(this.data.brandData)
    },
    mult_article() {
      return findCheck(this.data.articleData)
    },
    mult_autotend() {
      return findCheck(this.data.autotendData)
    },
    smart_volume() {
      return {
        planName: this.planName,
        auto_extend_enabled: this.plan.auto_extend_enabled,
        REGION: this.plan.district === 'NONE',
        GENDER: this.plan.gender === 'NONE',
        AGE: this.plan.age === 'NONE',
        CUSTOM_AUDIENCE: this.plan.retargeting_type === 'NONE',
        INTEREST_ACTION: this.plan.interest_action_mode === 'UNLIMITED'
      }
    },
    inventoryAll: {
      get: function () {
        if (this.plan.inventory_type) return this.plan.inventory_type.length === 6
        else return false
      },
      set: function (val) {
        this.$emit('on-change-inventory', val)
      }
    },
    isHideBrand() {
      return this.plan.platform && isArray(this.plan.platform) && this.plan.platform.includes('IOS') && this.plan.platform.length === 1
    },
    isShowAllBrand() {
      return (
        this.plan.platform &&
        ((this.plan.platform.includes('IOS') && this.plan.platform.includes('ANDROID')) || this.plan.platform === 'NONE')
      )
    }
  },
  watch: {
    mult_city(nVal, oVal) {
      if (nVal && nVal.length) {
        this.plan.city = nVal.map((ret) => ret.id)
        !this.plan.location_type && (this.plan.location_type = 'HOME')
      } else if (oVal.length && !nVal.length) {
        this.plan.city = []
        this.plan.location_type = undefined
      }
      if ((nVal.length || oVal.length) && nVal.length !== oVal.length) this.$emit('on-suggest')
    },
    mult_brand(nVal, oVal) {
      if (nVal && nVal.length) {
        this.plan.device_brand = nVal.map((ret) => ret.key)
      } else if (oVal.length && !nVal.length) {
        this.plan.device_brand = []
      }
      if ((nVal.length || oVal.length) && nVal.length !== oVal.length) this.$emit('on-suggest')
    },
    mult_article(nVal, oVal) {
      if (nVal && nVal.length) {
        this.plan.article_category = nVal.map((ret) => ret.key)
      } else if (oVal.length && !nVal.length) {
        this.plan.article_category = []
      }
      if ((nVal.length || oVal.length) && nVal.length !== oVal.length) this.$emit('on-suggest')
    },
    mult_autotend(nVal, oVal) {
      if (nVal && nVal.length) {
        this.plan.auto_extend_targets = nVal.map((ret) => ret.key)
      } else if (oVal.length && !nVal.length) {
        this.plan.auto_extend_targets = []
      }
      if ((nVal.length || oVal.length) && nVal.length !== oVal.length) this.$emit('on-suggest')
    },
    'plan.action_tags'(nVal) {
      if (isArray(nVal)) {
        this.plan.action_categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        this.plan.action_words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
      }
    },
    'plan.word_tags'(nVal) {
      if (isArray(nVal)) {
        this.plan.interest_categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        this.plan.interest_words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
      }
    },
    'plan.fan_tags'(nVal) {
      if (isArray(nVal)) {
        const categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        const words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
        this.$set(this.plan, 'aweme_fan_categories', categories)
        this.$set(this.plan, 'aweme_fan_accounts', words)
      }
    },
    'plan.inventory_type'(nVal) {
      if (isArray(nVal)) {
        if (this.plan.superior_popularity_type === 'GAME' && !this.superior) this.$set(this.plan, 'superior_popularity_type', 'NONE')
        if (this.superior) {
          this.$set(this.plan, 'carrier', 'NONE')
          this.$set(this.plan, 'activate_type', 'NONE')
          this.$set(this.plan, 'ac', 'NONE')
        }
      }
    },
    // 兴趣词包
    dataWords(nVal, oVal) {
      if (nVal && nVal.length) {
        this.plan.interest_tags = nVal.map((ret) => ret.id)
      } else {
        this.plan.interest_tags = []
      }
      if ((nVal.length || oVal.length) && nVal.length !== oVal.length) this.$emit('on-suggest')
    },
    // 人群包
    'plan.retargeting_tags': {
      handler(nVal) {
        if (isArray(nVal)) {
          this.plan.audiences = nVal.map((ret) => {
            return {
              account_id: ret.id,
              retargeting_tags_include: ret.includes.map((r) => r.id),
              retargeting_tags_exclude: ret.excludes.map((r) => r.id)
            }
          })
        }
      },
      deep: true
    },
    // 媒体包
    'plan.media_retargeting_tags': {
      handler(nVal) {
        if (isArray(nVal)) {
          this.plan.mediaAudiences = nVal.map((ret) => {
            return {
              account_id: ret.id,
              flow_package: ret.mediaIncludes.map((r) => r.id),
              exclude_flow_package: ret.mediaExcludes.map((r) => r.id)
            }
          })
        }
      },
      deep: true
    },
    includes: {
      handler() {
        this.updateAudienceData()
      },
      deep: true
    },
    excludes: {
      handler() {
        this.updateAudienceData()
      },
      deep: true
    },
    mediaIncludes: {
      handler() {
        this.updateMediaAudienceData()
      },
      deep: true
    },
    mediaExcludes: {
      handler() {
        this.updateMediaAudienceData()
      },
      deep: true
    },
    smart_volume: {
      handler(val) {
        this.data.autotendData.forEach((ret) => {
          if (val[ret.key]) {
            // 禁用 取消勾选
            this.$set(ret, 'check', false)
          }
          this.$set(ret, 'disabled', val[ret.key]) // 禁用
        })
      },
      deep: true
    }
  },
  methods: {
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      isArray(data) &&
        data.forEach((ret) => {
          if (ret.children && ret.children.length) {
            ret.children.map((rec) => {
              this.$set(rec, 'check', check)
              return rec
            })
          } else this.$set(ret, 'check', check)
        })
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    // 定位选择账号
    currentRetarget(id) {
      id && (this.current = id)
      const retargetingTags = this.plan.retargeting_tags ? this.plan.retargeting_tags.filter((ret) => ret.id === id).pop() : undefined
      if (retargetingTags) {
        const { includes, excludes } = retargetingTags
        this.includes = includes
        this.excludes = excludes
      } else {
        this.includes = []
        this.excludes = []
      }
      this.getAudienceData()
    },
    currentMediaRetarget(id) {
      id && (this.current = id)
      const retargetingTags = this.plan.media_retargeting_tags.filter((ret) => ret.id === id).pop()
      if (retargetingTags) {
        const { mediaIncludes, mediaExcludes } = retargetingTags
        this.mediaIncludes = mediaIncludes
        this.mediaExcludes = mediaExcludes
      } else {
        this.mediaIncludes = []
        this.mediaExcludes = []
      }
      this.getMediaAudienceData()
    },
    changePlanName(val) {
      this.$emit('on-name', val)
    },
    // 人群包选择
    changeRetargetingTags(params) {
      params.audience = 'append'
      this.$emit('on-audience-change', params)
    },
    changeMediaRetargetingTags(params) {
      params.audience = 'append'
      this.$emit('on-media-audience-change', params)
    },
    clearRetargetingTags(params) {
      params.audience = 'clear'
      this.$emit('on-audience-change', params)
    },
    clearMediaRetargetingTags(params) {
      params.audience = 'clear'
      this.$emit('on-media-audience-change', params)
    },
    deleteRetargetingTags(params) {
      params.audience = 'delete'
      this.$emit('on-audience-change', params)
    },
    deleteMediaRetargetingTags(params) {
      params.audience = 'delete'
      this.$emit('on-media-audience-change', params)
    },
    changeRetargetAll(params) {
      this.$emit('on-audience-all', params)
    },
    changeMediaRetargetAll(params) {
      const checkList = deepCopy(this.mediaAudienceList)
      this.$emit('on-media-audience-all', Object.assign({}, params, { checkList }))
    },
    changeRetarget(val) {
      if (val === 'NONE') {
        if (isArray(this.accounts) && this.accounts.length > 1) this.$emit('on-audience-clear')
        else this.clearRetargetingTags({ account: this.current })
        // this.resetAudience()
      }
    },
    changeMediaRetarget(val) {
      if (val === 'NONE' || val === 'GAME') {
        if (isArray(this.accounts) && this.accounts.length > 1) this.$emit('on-media-audience-clear')
        else this.clearMediaRetargetingTags({ account: this.current })
        // this.resetAudience()
      }
    },
    // 清空行为兴趣定向
    resetInterestAction() {
      this.$set(this.plan, 'action_scene', [])
      this.$set(this.plan, 'action_days', 30)
      this.$set(this.plan, 'action_tags', [])
      this.$set(this.plan, 'word_tags', [])
      this.$set(this.plan, 'action_categories', [])
      this.$set(this.plan, 'action_words', [])
      this.$set(this.plan, 'interest_categories', [])
      this.$set(this.plan, 'interest_words', [])
    },
    // 手机价格
    changePrice(val) {
      this.plan.launch_price = val === 'NONE' ? '' : [0, 11000]
    },
    changeDeviceType(val) {
      if (val === 'NONE') this.plan.device_type = []
    },
    changePriceValue(val) {
      this.plan.launch_price = val
    },
    getAudienceData() {
      const params = {
        account: this.current,
        pageIndex: 1,
        pageSize: 100
      }
      if (!this.current) return
      this.loading = true
      getCustomAudience(params).then((data) => {
        this.loading = false
        if (data && data.success) {
          if (isArray(data.models.retData)) {
            this.audienceList = data.models.retData.map((ret) => {
              return {
                id: ret.custom_audience_id,
                name: ret.name,
                source: ret.source
              }
            })
            this.updateAudienceData()
            this.currenTab = 'include'
          }
        } else {
          this.resetAudience()
          this.current = params.account
        }
      })
    },
    getMediaAudienceData() {
      const params = {
        account: this.current
      }
      if (!this.current) return
      this.loading = true
      getFlowPackage(params).then((data) => {
        this.loading = false
        if (data && isArray(data)) {
          this.mediaAudienceList = data.map((ret) => {
            return {
              id: ret.flow_package_id,
              name: ret.name,
              type: ret.flow_package_type
            }
          })
          this.updateMediaAudienceData()
          this.currenMediaTab = 'include'
        } else {
          this.resetMediaAudience()
          this.current = params.account
        }
      })
    },
    // 同步已选数据
    updateAudienceData() {
      const includes = this.includes.map((m) => m.id)
      const excludes = this.excludes.map((m) => m.id)
      const include = (met) => {
        if (includes.includes(met)) return 'include'
        else if (excludes.includes(met)) return 'exclude'
      }
      this.audienceList.forEach((ret) => {
        Object.assign(ret, { select: include(ret.id) })
      })
    },
    updateMediaAudienceData() {
      const includes = this.mediaIncludes.map((m) => m.id)
      const excludes = this.mediaExcludes.map((m) => m.id)
      const include = (met) => {
        if (includes.includes(met)) return 'include'
        else if (excludes.includes(met)) return 'exclude'
      }
      this.mediaAudienceList.forEach((ret) => {
        Object.assign(ret, { select: include(ret.id) })
      })
    },
    // 切换|添加 定向还原初始状态
    resetAudience() {
      this.audienceList = []
      this.current = 0
      this.currenTab = 'include'
      this.includes = []
      this.excludes = []
    },
    resetMediaAudience() {
      this.mediaAudienceList = []
      this.current = 0
      this.currenMediaTab = 'include'
      this.mediaIncludes = []
      this.mediaExcludes = []
    },
    setDays(val) {
      this.$set(this.plan, 'action_days', val)
    },
    setScene(val) {
      this.$set(this.plan, 'action_scene', val)
    },
    setBehavior(val) {
      this.$set(this.plan, 'aweme_fan_behaviors', val)
    },
    setTimes(val) {
      this.$set(this.plan, 'aweme_fan_time_scope', val)
    },
    resetAwemeAction() {
      this.$set(this.plan, 'fan_tags', [])
      this.$set(this.plan, 'aweme_fan_time_scope', 'FIFTEEN_DAYS')
      this.$set(this.plan, 'aweme_fan_behaviors', ['FOLLOWED_USER'])
    }
  },
  data() {
    return {
      loading: null,
      currenTab: 'include',
      currenMediaTab: 'include',
      audienceList: [],
      mediaAudienceList: [],
      dataWords: [], // 兴趣关键词
      current: 0,
      includes: [], // 传入预估人群定向
      excludes: [], // 传入预估人群排除
      mediaIncludes: [], // 传入预估人群定向
      mediaExcludes: [] // 传入预估人群排除
    }
  },
  created() {
    // this.updatedFlowPackage()
  }
}
</script>
<style lang="scss" scoped>
.c-target-wrap {
  position: relative;
}

.disabled-wrap {
  position: relative;
  // pointer-events none
  z-index: 1;

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }

  * {
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
